import React, { useEffect, useRef, useState } from 'react'
import { TextStyle, View } from 'react-native'
import {
  ALTERNATIVE_STATUS_DWELL_MS,
  ALTERNATIVE_STATUS_TYPE_SPEED_MS,
  pickAlternativeStatusPhrase,
} from '@ecountabl/lib'
import Typewriter from '../utility/typewriter'
import Loader from '../utility/loader'

type Props = {
  style?: TextStyle | TextStyle[]
}

export const AlternativeStatus: React.FC<Props> = ({ style }) => {
  const [phrase, setPhrase] = useState(() => pickAlternativeStatusPhrase())
  const dwellTimer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    return () => {
      if (dwellTimer.current) clearTimeout(dwellTimer.current)
    }
  }, [])

  const onComplete = () => {
    if (dwellTimer.current) clearTimeout(dwellTimer.current)
    dwellTimer.current = setTimeout(() => {
      setPhrase((current) => pickAlternativeStatusPhrase(current))
    }, ALTERNATIVE_STATUS_DWELL_MS)
  }

  return (
    <View style={{ width: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 10 }}>
      <Loader />
      <Typewriter
        text={phrase}
        speed={ALTERNATIVE_STATUS_TYPE_SPEED_MS}
        style={style}
        onComplete={onComplete}
      />
    </View>
    
  )
}

export default AlternativeStatus
